module.exports = __webpack_public_path__ + "static/img/2.3ebf4cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/zh/2.png
// module id = T5vS
// module chunks = 0